import { fabric } from "@utils/fabric";
import { TypeBold } from "react-bootstrap-icons";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";

function FontWeight({
  disabled = false,
  onChange = () => {},
}: {
  disabled: boolean;
  onChange: () => void;
}) {
  const { selectedObject } = useContext(AppContext);
  const [fontWeight, setFontWeight] = useState(
    (selectedObject as fabric.Textbox)?.fontWeight
  );

  // triggered by clicking layers
  useEffect(() => {
    setFontWeight((selectedObject as fabric.Textbox)?.fontWeight);
  }, [selectedObject]);

  function onClick() {
    const newFontWeight = fontWeight === "normal" ? "bold" : "normal";
    setFontWeight(newFontWeight);
    (selectedObject as fabric.Textbox)?.set({ fontWeight: newFontWeight });

    // notify parent to load font and update canvas
    onChange();
  }

  return (
    <button
      disabled={disabled}
      className={`flex items-center justify-center h-9 w-9 rounded-lg border transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${
        fontWeight === "bold" 
          ? "bg-blue-500 border-blue-500 text-white shadow-sm" 
          : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50 hover:border-gray-400"
      }`}
      onClick={onClick}
    >
      <TypeBold size={16} />
    </button>
  );
}

export default FontWeight;
